import React, { useEffect } from "react";
import Modal from "../../components/Modal/Modal";
import SellerRegNavbar from "../../components/Seller/SellerRegNavbar/SellerRegNavbar";
import { useAuth } from "../../context/AuthContext";
import { Link, useNavigate } from "react-router-dom";

function Seller() {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  // Use useEffect to handle redirection without causing an infinite loop
  // useEffect(() => {
  //   if (isAuthenticated) {
  //     navigate('/seller/dashboard');
  //   }
  // }, [isAuthenticated, navigate]);
  return (
    <div className="container mx-auto">
      {/* Background Section */}
      <SellerRegNavbar />
      <div className="relative h-[400px] overflow-hidden">
        <img
          src="\images\auth\sellerInfoBg.jpg"
          alt="Background"
          className="h-full w-full object-fill"
        />
        <div className="absolute inset-0 flex items-center bg-black bg-opacity-0">
          <div className="relative z-20 w-full flex-initial p-4 md:w-1/2 md:p-8">
            <h1 className="text-center text-5xl text-black md:text-left md:text-6xl">
              Be Our Seller
            </h1>
            <p className="mt-4 text-center text-sm text-gray-800 md:text-left">
              Grow your business with us - reach more customers, earn more
              sales.
            </p>
            <div className="mt-10">
              <Link
                to={"/seller/register"}
                className="rounded-lg bg-green-600 px-14 py-3 font-medium text-white shadow hover:bg-green-700"
              >
                Start Selling
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Statistics Section */}
      {/* <div className="w-full bg-green-100 py-12 text-center">
        <div className="ml-7 grid grid-cols-2 gap-8 p-14 md:grid-cols-4 md:gap-36">
          {[
            { title: "6500+", subtitle: "Customers" },
            { title: "120+", subtitle: "Sellers" },
            { title: "20000+", subtitle: "Orders" },
            { title: "1800+", subtitle: "Products" },
          ].map((stat, index) => (
            <div
              key={index}
              className={`w-28 rounded-br-3xl rounded-tl-3xl bg-white p-6 shadow-lg md:w-36 ${
                index % 2 === 0 ? "mb-24" : "mt-24"
              }`}
            >
              <h2 className="text-xl font-bold text-gray-800 md:text-2xl">
                {stat.title}
              </h2>
              <p className="text-gray-600">{stat.subtitle}</p>
            </div>
          ))}
        </div>
      </div> */}

      {/* Services Section */}
     {/* Services Section */}
<div className="py-10 text-center">
  <h3 className="mb-2 text-2xl font-bold">What We Do</h3>
  <p className="mb-10 text-lg text-gray-600">For Your Business</p>

  <div className="flex flex-wrap justify-center gap-28">
    {/* Service 1 */}
    <div className="flex max-w-64 flex-col items-center rounded-2xl bg-brand-light-gray p-6 text-center shadow-2xl">
      <img
        src="/images/logo/dashboard.png"
        alt="Dashboard"
        width="50"
        className="mb-4"
      />
      <h4 className="mb-2 text-xl font-bold">Reach More Customers</h4>
      <p className="mb-4 text-sm text-gray-600">
        List your products on our platform and get discovered by thousands of
        active buyers every day without spending on ads.
      </p>
      {/* <button className="rounded-lg bg-green-600 px-6 py-2 font-bold text-white">
        Learn More
      </button> */}
    </div>

    {/* Service 2 */}
    <div className="flex max-w-64 flex-col items-center rounded-2xl bg-brand-light-gray p-6 text-center shadow-2xl">
      <img
        src="/images/logo/dashboard.png"
        alt="Orders"
        width="50"
        className="mb-4"
      />
      <h4 className="mb-2 text-xl font-bold">Manage Orders Easily</h4>
      <p className="mb-4 text-sm text-gray-600">
        Track orders, update delivery status, and manage cancellations from a
        single dashboard designed for sellers.
      </p>
      {/* <button className="rounded-lg bg-green-600 px-6 py-2 font-bold text-white">
        Learn More
      </button> */}
    </div>

    {/* Service 3 */}
    <div className="flex max-w-64 flex-col items-center rounded-2xl bg-brand-light-gray p-6 text-center shadow-2xl">
      <img
        src="/images/logo/dashboard.png"
        alt="Payments"
        width="50"
        className="mb-4"
      />
      <h4 className="mb-2 text-xl font-bold">Secure & Timely Payments</h4>
      <p className="mb-4 text-sm text-gray-600">
        Get transparent earnings reports and receive payouts directly to your
        bank account with complete payment tracking.
      </p>
      {/* <button className="rounded-lg bg-green-600 px-6 py-2 font-bold text-white">
        Learn More
      </button> */}
    </div>
  </div>
</div>

    </div>
  );
}

export default Seller;
